import React from 'react';
import '../styles/TeamCrest.css';

/*
 * The upstream feed ships no team logos (every `image` field is empty), so a
 * shared placeholder made all six teams look identical. Instead we derive a
 * stable monogram crest from the team name: same team, same colour, every time.
 *
 * Hues are drawn from a curated set rather than a raw hash-to-hue so the board
 * never lands on muddy or clashing colours.
 */

const CREST_COLORS = [
  '#4A90FF', // azure
  '#FF7A2F', // ember
  '#22C7A9', // teal
  '#B36BFF', // violet
  '#FFC53D', // amber
  '#FF5C8A', // rose
  '#5AD1FF', // ice
  '#8ED14F', // lime
];

function hashCode(value = '') {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash << 5) - hash + value.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash);
}

export function crestColor(name = '') {
  return CREST_COLORS[hashCode(name) % CREST_COLORS.length];
}

export function initialsFor(name = '') {
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '??';
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}

/**
 * @param {string} name  team name
 * @param {'sm'|'md'|'lg'} [size]
 */
const TeamCrest = ({ name, size = 'md' }) => {
  const color = crestColor(name);
  return (
    <span
      className={`crest crest-${size}`}
      style={{ '--crest': color }}
      aria-hidden="true"
    >
      {initialsFor(name)}
    </span>
  );
};

export default TeamCrest;
